// src/App.jsx
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider, App as AntApp, theme as antdTheme } from 'antd';
import { IntlProvider } from 'react-intl';
import { ToastContainer } from 'react-toastify';

import CookieBanner from './components/common/CookieBanner';
import { ThemeProvider, useTheme } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext'; // Assuming this exists based on earlier context
import AppRoutes from './routes/AppRoutes';
import { MESSAGES } from './lib/i18n';

function ThemedApp() {
    const { isDark, isRtl, locale } = useTheme();

    return (
        <IntlProvider
            locale={locale}
            defaultLocale="en"
            messages={MESSAGES[locale]}
            onError={(err) => {
                // Silence noisy missing-translation warnings in dev
                if (err.code === 'MISSING_TRANSLATION') return;
                // eslint-disable-next-line no-console
                console.error(err);
            }}
        >
            <ConfigProvider
                direction={isRtl ? 'rtl' : 'ltr'}
                theme={{
                    algorithm: isDark ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
                    token: {
                        borderRadius: 8,
                        // Apply RTL font automatically when language is Persian
                        fontFamily: isRtl
                            ? "'Vazirmatn', 'Tahoma', 'Inter', sans-serif"
                            : "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
                    },
                }}
            >
                <AntApp>
                    <BrowserRouter>
                        <AuthProvider>
                            <CartProvider>
                                <AppRoutes />
                                <ToastContainer
                                    position={isRtl ? 'top-left' : 'top-right'}
                                    autoClose={3000}
                                    theme={isDark ? 'dark' : 'light'}
                                />
                            </CartProvider>
                        </AuthProvider>
                        <CookieBanner />
                    </BrowserRouter>
                </AntApp>
            </ConfigProvider>
        </IntlProvider>
    );
}

export default function App() {
    return (
        <ThemeProvider>
            <ThemedApp />
        </ThemeProvider>
    );
}